
/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import LoadingIndicator from '../../components/LoadingIndicator';
import { Helmet } from 'react-helmet';
import { selectLoading } from '../TermsAndConditions/selectors';

export class App extends React.PureComponent {
  render() {
    let content = React.Children.toArray(this.props.children);
    if (this.props.loading) {
      content = <LoadingIndicator />;
    }
    return (
      <div>
        <Helmet
          titleTemplate="%s - DAVA"
          defaultTitle="Digital Account Viewing Agreement"
          meta={[
            { name: 'description', content: 'Digital Account Viewing Agreement' },
          ]}
        />
        {content}
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  loading: selectLoading(),
});

export default connect(mapStateToProps, null)(App);
